import {AppRouter} from '@/components/AppRouter'
import {DEFAULT_INTL} from '@/config/constants'
// import {AuthProvider} from '@/helpers/Auth/AuthProvider'
import {msalInstance} from '@/helpers/authConfig'
import useInternationalization from '@/internationalization/useInternationalization'
import {MsalProvider} from '@azure/msal-react'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {ThemeProvider} from 'pepsico-ds'
import {IntlProvider} from 'react-intl'
import {Provider} from 'react-redux'
import {RouterProvider, createBrowserRouter} from 'react-router-dom'
import './assets/scss/App.scss'
import {store} from './store'

interface AppProps {
  shellActive?: boolean
  path?: string
  darkTheme?: boolean
  market?: string
}

interface RootProps {
  shellActive: boolean
  path: string
  darkTheme: boolean
  market: string
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
})

function Root({shellActive, darkTheme, path, market}: RootProps) {
  const [language, message] = useInternationalization(DEFAULT_INTL)
  const theme = darkTheme ? 'Dark Peacock' : 'Light Peacock'

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <IntlProvider locale={language} messages={message}>
          {/* <AuthProvider> */}
          <MsalProvider instance={msalInstance}>
            <ThemeProvider data-testid="theme-provider" defaultStyle={theme}>
              <AppRouter shellActive={shellActive} darkTheme={darkTheme} path={path} market={market} />
            </ThemeProvider>
          </MsalProvider>
          {/* </AuthProvider> */}
        </IntlProvider>
      </QueryClientProvider>
    </Provider>
  )
}

export default function App({shellActive = false, darkTheme = false, path = '/', market = 'MX'}: AppProps) {
  const router = createBrowserRouter([
    {
      path: '*',
      element: <Root shellActive={shellActive} darkTheme={darkTheme} path={path} market={market} />,
    },
  ])

  return <RouterProvider router={router} />
}
